import React, { Fragment, useCallback, useEffect, useState } from 'react';
import { getIdTargetOnThisPage, parseContentHTML } from 'helpers/string';
import { cloneDeep, isArray } from 'lodash';
import classNames from 'classnames';
import Timer from 'helpers/setTimer';
import { Link, animateScroll as scroll } from 'react-scroll';
import 'react-quill/dist/quill.snow.css';
import SearchBar from './SearchBar';
import { findIndexOfAllRepeatationOfStringInString } from 'helpers';

const timerDetectId = new Timer();
const Content = ({ dataGuideLine }) => {
  const [contentSelected, setContent] = useState({});
  const [listOnThisPage, setListOnThisPage] = useState([]);

  //! Effect
  useEffect(() => {
    if (isArray(dataGuideLine) && dataGuideLine.length > 0) {
      setContent(dataGuideLine[0]);
    }
  }, [dataGuideLine]);

  // Detect id and text for OnThisPage
  useEffect(() => {
    const listId = getIdTargetOnThisPage(contentSelected.content || '');
    timerDetectId.debounce(() => {
      let tempArr = [];
      (listId || []).forEach((id) => {
        tempArr = [
          ...tempArr,
          {
            id,
            text: document.querySelector(id)?.textContent,
          },
        ];
      });
      const interval = setInterval(() => {
        let count = 0;
        const element = document.getElementById('destination');
        if (element) {
          //* Scroll to element
          //* 200px is height of header
          const y = element.getBoundingClientRect().top + window.pageYOffset - 350;
          window.scrollTo({ top: y, behavior: 'smooth' });
          //window scroll top 100px
          clearInterval(interval);
        }
        count++;
        if (count > 10) clearInterval(interval);
      }, 500);
      setListOnThisPage(tempArr);
    }, 0);
  }, [contentSelected]);

  const onClickMenu = (item) => (e) => {
    e.stopPropagation();
    scroll.scrollToTop();
    setContent(item);
  };

  //! Function

  const handleSearch = useCallback(
    (inputValue) => {
      if (!inputValue) return;
      const newData = cloneDeep(dataGuideLine);

      const regTag = /(&nbsp;|<([^>]+)>)/gi;
      newData.forEach((el) => {
        el.noTagContent = el.content.replace(regTag, '');
      });

      const searchOption = [];
      newData.forEach((el) => {
        const indexList = findIndexOfAllRepeatationOfStringInString(
          cloneDeep(el?.content.toLowerCase()),
          inputValue.toLowerCase()
        );

        indexList.forEach((pos, index) => {
          //*Limit search result to
          if (index > 10) return;

          searchOption.push({
            ...el,
            value: el?.id,
            inText: () => {
              const cloneContent = cloneDeep(el?.content.toLowerCase());
              //* Find start and end position of tag
              const stopPos = cloneContent.slice(pos + inputValue.length).indexOf('<');
              const startPos = cloneContent
                .slice(0, pos)
                .split('')
                .reverse()
                .join('')
                .indexOf('>');

              return (
                <div>
                  {cloneContent.slice(pos - startPos, pos).replace(regTag, '')}
                  <span>
                    <strong>{inputValue}</strong>
                  </span>
                  {cloneContent
                    .slice(pos + inputValue.length, pos + inputValue.length + stopPos)
                    .replace(regTag, '')}
                </div>
              );
            },
            //regex remove tag

            inTab: el?.title,
            searchFrom: inputValue,
            index: pos,
          });
        });
      });

      return searchOption;
    },
    [dataGuideLine]
  );

  //! Render
  return (
    <Fragment>
      <SearchBar handleSearch={handleSearch} setContent={setContent} />
      <div className='content-container ql-snow'>
        <div className='left'>
          <div className='left__menu'>
            <span className='title'>Features</span>
            <div className='list-page'>
              {isArray(dataGuideLine) &&
                cloneDeep(dataGuideLine)
                  .sort((val1, val2) => val1.order - val2.order)
                  .map((el) => (
                    <div
                      key={el.id}
                      className={classNames('each-page', {
                        'is-active': el.id === contentSelected.id,
                      })}
                      onClick={onClickMenu(el)}
                    >
                      {el.title}
                    </div>
                  ))}
            </div>
          </div>
        </div>

        <div
          className='center ql-editor'
          dangerouslySetInnerHTML={{
            __html: parseContentHTML(contentSelected.content),
          }}
        />

        <div className='right'>
          <div className='right__on-this-page'>
            <span className='title'>On this page</span>
            <div className='list-item'>
              {listOnThisPage.map((ele) => (
                <Link
                  key={ele.id}
                  className='item'
                  to={ele.id?.replace('#', '')}
                  spy={true}
                  offset={-100}
                  smooth={true}
                >
                  {ele.text}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Content;
